export default "__VITE_ASSET__BKQhclv1__"